var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/react-query-hooks/use-league-infinite-ws-query/use-league-infinite-ws-query.hook.ts
import {
  useInfiniteQuery
} from "react-query";
import { SocketAsFetch } from "@leagueplatform/socket-as-fetch";
function useLeagueInfiniteWSQuery(queryKey, {
  info,
  message_type,
  responseKey,
  offsetParam = "offset"
}, options) {
  const { limit } = info;
  return useInfiniteQuery(
    queryKey,
    (_0) => __async(this, [_0], function* ({ pageParam = 0 }) {
      const res = yield SocketAsFetch.fetch({
        message_type,
        info: __spreadProps(__spreadValues({}, info), { [offsetParam]: pageParam })
      });
      return res[responseKey];
    }),
    __spreadValues({
      getNextPageParam: (lastPage, pages) => {
        if (lastPage.length < limit) {
          return void 0;
        }
        return pages.length * limit;
      }
    }, options)
  );
}

// src/react-query-hooks/use-league-ws-mutation/use-league-ws-mutation.hook.ts
import { useMutation } from "react-query";
import { SocketAsFetch as SocketAsFetch2 } from "@leagueplatform/socket-as-fetch";
function useLeagueWSMutation(message_type, options) {
  return useMutation(
    (info) => __async(this, null, function* () {
      if (info) {
        return SocketAsFetch2.fetch({
          message_type,
          info
        });
      }
      throw new Error("Please provide your Websocket message information");
    }),
    // consumers can leverage any of RQ options in their mutation
    options
  );
}

// src/react-query-hooks/use-league-ws-query/use-league-ws-query.hook.ts
import { useQuery } from "react-query";
import { SocketAsFetch as SocketAsFetch3 } from "@leagueplatform/socket-as-fetch";
function useLeagueWSQuery(queryKey, { info, message_type }, options) {
  return useQuery(
    queryKey,
    () => __async(this, null, function* () {
      return SocketAsFetch3.fetch({
        message_type,
        info
      });
    }),
    // consumers can leverage any of RQ options in their query
    options
  );
}
export {
  useLeagueInfiniteWSQuery,
  useLeagueWSMutation,
  useLeagueWSQuery
};


  if (typeof window !== 'undefined' && !(typeof process !== 'undefined' && process.env?.NODE_ENV === 'test')) {
    window.leagueSDKsPresent = window.leagueSDKsPresent || [];
    window.leagueSDKsPresent['@leagueplatform/api'] = window.leagueSDKsPresent['@leagueplatform/api'] || [];
    window.leagueSDKsPresent['@leagueplatform/api'].push('2.23.5');

    const numInstances = window.leagueSDKsPresent['@leagueplatform/api'].length

    if (numInstances > 1) {
      console.error('Multiple copies (' + numInstances + ') of the @leagueplatform/api module are loaded! This can cause issues. Ensure that your project bundle only contains one copy/version of each League SDK package.');
    }
  }
  
//# sourceMappingURL=index.js.map